import styled from '@emotion/styled';
import Icons from '@shared/components/core/images/Icons';
import {
    ActionWrapper,
    Content,
    EmptyContent,
    ListingCard,
    Table,
    TableHeading,
} from '@shared/components/core/listing/CommonListingStyles';
import { CardTitleCentered } from '@shared/components/core/text/CardTypography';
import { BodySmall } from '@shared/components/core/text/Typography';
import { commandTypesDisplay } from '@shared/constants/CommandValues';
import { useTranslation } from 'react-i18next';

export interface IDictationListingProps {
    dictationCommands: string[];
    showDescription?: boolean;
}

function DictationListing({ dictationCommands, showDescription = true }: IDictationListingProps) {
    const { t } = useTranslation();
    const icon = commandTypesDisplay['dictation'];
    return (
        <ListingCard>
            {dictationCommands.length > 0 ? (
                <>
                    <CardTitleCentered>{t('common:dictation.title')}</CardTitleCentered>
                    {showDescription && <BodySmall>{t('common:dictation.description')}</BodySmall>}

                    <Table>
                        <thead>
                            <ActionWrapper>
                                <Content as="th">
                                    <TableHeading>{t('common:voice.when')}</TableHeading>
                                </Content>
                                <Content as="th">
                                    <TableHeading>{t('common:dictation.thenMacro')}</TableHeading>
                                </Content>
                            </ActionWrapper>
                        </thead>
                        <tbody>
                            {dictationCommands.map((command, i) => {
                                return (
                                    <ActionWrapper key={`commandKeyMappings_${i}_${command}`}>
                                        <Content>
                                            <Icons name={icon.icon} size={24} ariaLabel={t(icon.title)} />
                                            <p>{command}</p>
                                        </Content>
                                        <Content>
                                            <Transcribe>{t('common:dictation.type')}</Transcribe>
                                            <Icons name="keyboard" size={24} ariaLabel={t('common:steps')} />
                                        </Content>
                                    </ActionWrapper>
                                );
                            })}
                        </tbody>
                    </Table>
                </>
            ) : (
                <EmptyContent>{t('common:dictation.empty')}</EmptyContent>
            )}
        </ListingCard>
    );
}

const Transcribe = styled.p`
    font-weight: 100;
    font-style: italic;
`;

export default DictationListing;
